import axios from '../../http'
import {API} from "../../const"

const api = API+'/v2/goods/freight-price';

const error = (name) => (e) => console.error(name + ':=>', e);

export default function getFreightPrice(params, cb, fcb = error('getFreightPrice')) {
  axios.get(api, {params}).then(response => {
    cb(response.data);
  }).catch(response => {
    fcb(response);
  })
}